// extracted by mini-css-extract-plugin
module.exports = {"discountText":"DiscountLine_discountText__rxH2a"};